import { useState } from "react"
import { Button, Modal } from "@prosolve/common-components-ui"
import useFetch from "../../hooks/useFetch";
import ActionButton from "../Shared/ActionButton";
import useShipmentSnackbar from "../Shared/useShipmentSnackbar";
import { checkHasShipmentExperimentalEnabled } from "../../utils";

// If product is present, the form will edit instead.
export default ({
  wro,
  updateWROData
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isBusy, setIsBusy] = useState(false);

  const shipmentSnackbar = useShipmentSnackbar()

  const fetch = useFetch();

  const isShipExpOn = checkHasShipmentExperimentalEnabled();

  const cancelWRO = async () => {
    setIsBusy(true)
    try {

      const urlEndpoint = `shipping/wro/cancel`
      const data = {
        id: wro.id
      }
      const response = await fetch(urlEndpoint, { 
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data)
        }
      )

      const jsonData = await response.json();
      if (jsonData.error) {
        console.error(jsonData.error)
        shipmentSnackbar.newMessage({ message: 'Error cancelling WRO', severity: 'failure' })
      } else {
        updateWROData(wro, false)
        onClose()
      }
      
    } catch (e) {
      console.error(e)
      shipmentSnackbar.newMessage({ message: 'Error cancelling WRO', severity: 'failure' })
    }
    setIsBusy(false)
  }

  const onClose = () => {
    setIsModalOpen(false)
  }

  const onClickSubmit = () => {
    //console.log(formData.values)
    cancelWRO()
  }

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      fontSize: '16px',
      fontWeight: 'normal',
      padding: '10px'
    }}>
      {
        Boolean(isBusy) &&
        <div>{'Updating...'}</div>
      }
      <Button onClick={() => (!isBusy && onClose())} $disabled={isBusy}>
        {'Cancel'}
      </Button>
      <Button onClick={() => (!isBusy && onClickSubmit())} $disabled={isBusy} $colored={true}>
        {'Submit'}
      </Button>
    </div>
  )

  return (
    <>
      {isModalOpen && 
        <Modal title={'Create Order'} onClose={onClose} footer={footer}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            fontSize: '14px',
            fontWeight: 'normal'
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              rowGap: '15px'
            }}>
              Are you sure you want to cancel WRO: #{wro?.id}
            </div>
          </div>
        </Modal>
      }
      {/* SB_DISABLED - This is disabled until create/edit WRO is fully implemented */}
      <ActionButton onClick={() => setIsModalOpen(true)} style={{ ...(!isShipExpOn && { display: 'none' }) }}>
        Cancel WRO
      </ActionButton>
    </>
  )
}